import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        show: false,
        title: 'Notification',
        message: 'This is a toast message.',
        delay: 3000,
        autohide: true,
        position: "top-end"
    });

    const showToast = (title, message, delay = 3000, autohide = true, position = "top-end") => {
        setToast({ show: true, title, message, delay, autohide, position });
        setTimeout(() => setToast({ ...toast, show: false }), delay); 
    };

    return (
        <ToastContext.Provider value={{ toast, showToast }}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
